import { render, staticRenderFns } from "./shopAssistantq.vue?vue&type=template&id=6ffe62bc&scoped=true"
import script from "./shopAssistantq.vue?vue&type=script&lang=js"
export * from "./shopAssistantq.vue?vue&type=script&lang=js"
import style0 from "./shopAssistantq.vue?vue&type=style&index=0&id=6ffe62bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe62bc",
  null
  
)

export default component.exports